import { Injectable } from '@angular/core';
import {
  HammerGestureConfig,
  HAMMER_GESTURE_CONFIG,
} from '@angular/platform-browser';

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  override overrides = {
    press: { time: 600 }, // duración para long-press
    swipe: { direction: Hammer.DIRECTION_ALL },
  } as any;
}